import { FilterFn } from '../interfaces/FilterFn';

export function createStringFilterFunction<T>(predicate: (item: T) => unknown): FilterFn<T, string> {
  return (item: T, filterValue: string) => {
    const value = predicate(item);

    return typeof value === 'string' ? value.toLowerCase().includes(filterValue) : false;
  };
}
